module.exports = __webpack_public_path__ + "assets/img/icon_pause.60d8cf89.png";